import { CrudFormType } from "../../../../shared/form/types/FormTypes";
import { useLangLabels } from "../../../../shared/lang/services/useLangLabels";
import { CarrousellActionInterface } from "../../../../shared/react-table/VirtualGrid/types/VirtualGridTypes";
import VirtualGrid from "../../../../shared/react-table/VirtualGrid/VirtualGrid";
import CreateUpdateBrandForm from "../../domain/instrument-brands/components/CreateUpdateBrandForm";
import { DeleteBrandForm } from "../../domain/instrument-brands/components/DeleteBrandForm";
import { useBrandGridModel } from "../../domain/instrument-brands/lang/useBrandGridModel";
import { useGetAllBrands } from "../../domain/instrument-brands/services/brandService";

export const ManageBrandPage = ({ fixedHeight }: { fixedHeight?: number }) => {
  const { lang } = useLangLabels();
  const { data: brands, isFetching } = useGetAllBrands();

  const carrousellActions: CarrousellActionInterface = [
    {
      icon: "edit",
      popoverTitle: lang.crudActions.update,
      component: item => (
        <CreateUpdateBrandForm
          item={item}
          actionType={CrudFormType.update}
          isDataUpdated={!isFetching}
        />
      ),
    },
  ];

  return (
    <VirtualGrid
      gridModel={useBrandGridModel()}
      fixedHeight={fixedHeight}
      title={lang.instruments.brands.title.plural}
      entityName={lang.instruments.brands.title.plural}
      items={brands}
      carrousellComponents={carrousellActions}
      headerActions={() => <CreateUpdateBrandForm actionType={CrudFormType.create} />}
      itemActions={item => <DeleteBrandForm item={item} />}
    />
  );
};
